<template>
    <div class="header-apr">
        <collapseApr ref="collapseApr" :formSearch="formSearch"></collapseApr>
    </div>
</template>

<script>
import registerTable from './registerTable'
export default registerTable
</script>

<style scoped>
.header-apr {
    background-color: white;
    height: 100%;
}
#impor-ex-price{
display: none;
}
.novoTemplate {
    padding: 0.5rem 3rem 0.5rem 3rem
}
.descricaoArea{
    width: 100%;
    height: 5rem;
    border-color: #b3b3b3;
    border-radius: 1px;
}
.header-title{
color: white;
font-weight: bold;
font-size: 16px;
font-family: 'Segoe UI';
}
.btn-generate-lote {
    height: 2rem;
    padding: 0 1rem;
    background: #008144;
    color: white;
    border-radius: 4px;
    border: none;
    font-size: 12px;
}
.btn-generate-lote:hover{
    background: #024d2a;
}
.button-cancel,
.button-save{
margin-top: 10;
font-size: 12PX;
outline: transparent;
border: transparent;
border-radius: 4px;
text-transform: uppercase;
width: 190px;
height: 40px;
}

.container_cancel_save{
justify-content: center;
width: 100%;
margin-top: 1.5rem;
column-gap: 10px;
}

.button-cancel{
background-color: #b60000;
color: white;
}
.button-save{
background-color: darkgreen;
color: white;

}
</style>



// WEBPACK FOOTER //
// src/views/private/apr/registerApr/components/registerTable/registerTable.vue